import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Loader from '../../shared/loader';
import ChangeMunicipalityModal from '../modals/change-municipality-modal';

class CityField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModalNoticeChange: false,
            nextValue: null,
        };

        this.preHandleCityChange = this.preHandleCityChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.onAcceptChange = this.onAcceptChange.bind(this);
        this.onCancelChange = this.onCancelChange.bind(this);
    }

    onAcceptChange() {
        this.setState((prevState) => ({
            ...prevState,
            showModalNoticeChange: false,
        }));

        if (this.props.noticeChange) {
            const {
                setCurrentMunicipality, availableMunicipalities,
                emptyCurrentCart, goToHome,
            } = this.props.noticeChange;

            const nextMunicipality = availableMunicipalities.find((municipality) => municipality.name === this.state.nextValue);
            if (nextMunicipality) {
                setCurrentMunicipality(nextMunicipality.id);
            }
            goToHome();
            emptyCurrentCart().finally(() => {
                window.scrollTo(0, 0);
            });
        }
        this.handleCityChange(this.state.nextValue);
        this.setState((prevState) => ({
            ...prevState,
            nextValue: null,
        }));
    }

    onCancelChange() {
        this.setState((prevState) => ({
            ...prevState,
            showModalNoticeChange: false,
            NextValue: null,
        }));
    }

    preHandleCityChange(event) {
        event.persist();
        if (this.props.noticeChange) {
            this.setState((prevState) => ({
                ...prevState,
                showModalNoticeChange: true,
                nextValue: event.target.value,
            }));
        } else {
            this.handleCityChange(event.target.value);
        }
    }

    handleCityChange(value) {
        this.props.handleCityChange(value);
        // Trigger the redux-form onChange callback.
        this.props.input.onChange(value);
        this.props.input.onBlur();
    }

    render() {
        const { meta: { touched, error } } = this.props;
        let errorClassName = '';
        if (touched && error) {
            errorClassName = 'has-error ';
        }

        const cityOptionsMarkup = this.props.cities.map((city, idx) => (
            <option key={idx} value={city.name}>
                {city.name}
            </option>
        ));

        return (
            <div style={{ position: 'relative' }} className={`${errorClassName}`}>

                <ChangeMunicipalityModal
                    show={this.state.showModalNoticeChange}
                    onAccept={this.onAcceptChange}
                    onCancel={this.onCancelChange}
                />

                <select
                    name={`${this.props.fieldNamePrefix}[city]`}
                    onChange={this.preHandleCityChange}
                    className="form-control primary-input-field"
                    value={this.props.input.value}
                    disabled={(!this.props.displayLoader && this.props.cities.length === 0) || this.props.disabled}
                >
                    <option value="" disabled>{this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })}</option>
                    {cityOptionsMarkup}
                </select>
                <div style={{
                    position: 'absolute', top: '5px', right: '4px', backgroundColor: !this.props.displayLoader && this.props.cities.length === 0 ? '#eee' : '#fff',
                }}
                >
                    <Loader displayLoader={this.props.displayLoader} size={25} />
                </div>
                {touched && error && <span className="help-block">{error}</span>}
            </div>
        );
    }
}

export default injectIntl(CityField);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/address/city-field.jsx
 **/